export default "__VITE_ASSET__810e0e1a__"